import { z } from "zod";

export const appmixerType = z.enum([
  "boolean",
  "number",
  "object",
  "string",
  "array",
]);
